import { BaseComponent } from '@components/base.component';
import { Component, Input, OnInit } from '@angular/core';
import { BaseballMlbMapFce, BasketballMapFce, Team } from '@interfaces/match-data.interface';
import { ClientService } from '@services/client.service';
import { SourceId } from '@interfaces/source.interface';
import { toPairs } from 'lodash-es';

@Component({
    selector: 'app-timeline-baseball-mlb',
    templateUrl: './baseball-mlb-timeline.component.html',
    styleUrls: ['./baseball-mlb-timeline.component.scss'],
})
export class BaseballMlbTimelineComponent extends BaseComponent implements OnInit {
    @Input() data: BaseballMlbMapFce;
    @Input() sportName: string;
    @Input() sportId: number;
    @Input() home: Team | null = null;
    @Input() away: Team | null = null;

    public isUnknown = false;

    public console = console;

    constructor(private client: ClientService) {
        super();
    }

    ngOnInit(): void {
        // console.log(`${this.sportName} data`, _.toPairs(this.data));

        this.isUnknown = Object.values(this.data)[0]!
            .some((value: Record<string, any>) => value.source_id === SourceId.BETSAPI);
    }

    get actions(): [string, Record<string, any>[]][] {
        return toPairs(this.data);
    }

    get color(): string {
        return this.client.has('colors', 'icons') || 'black';
    }

    public participant = (qualifier: string): Team | null => {
        if (qualifier === 'home') {
            return this.home;
        }

        if (qualifier === 'away') {
            return this.away;
        }

        return null;
    };

    isTypeText(_type: string): boolean {
        return false;
    }

    isActionCollapsible(action: BasketballMapFce): boolean {
        return (action?.players?.length ?? 0) > 0;
    }
}
